import { render, staticRenderFns } from "./Park.vue?vue&type=template&id=148bb246&scoped=true&"
import script from "./Park.vue?vue&type=script&lang=js&"
export * from "./Park.vue?vue&type=script&lang=js&"
import style0 from "./Park.vue?vue&type=style&index=0&id=148bb246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148bb246",
  null
  
)

export default component.exports